import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useUser } from "../../context/UserContext";

function Chat({ selectedText, onResponse, onLoading, apiBaseUrl }) {
  const inputRef = useRef(null);
  const menuRef = useRef(null); // Ref for menu
  const [inputValue, setInputValue] = useState("");
  const [menuOpen, setMenuOpen] = useState(false);
  const [submenuOpen, setSubmenuOpen] = useState(false);
  const [showPopupMenu1, setShowPopupMenu1] = useState(false);
  const [showPopupMenu2, setShowPopupMenu2] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const [searchResult, setSearchResult] = useState(null);
  const [idInput, setIdInput] = useState("");
  const [currentStep, setCurrentStep] = useState("A");
  const { user, setUser } = useUser();
  const [formData, setFormData] = useState({

    // Section A+B
    name: "",
    postal_address: "",
    contact_number: "",
    email: "",
    marital_status: "",
    period: "",

    // Section C - Applicant
    applicant_surname: "",
    applicant_maiden_name: "",
    applicant_fullnames: "",
    applicant_gender: "",
    applicant_race: "",
    applicant_rsa_id: "",

    // Section C - Spouse
    spouse_surname: "",
    spouse_maiden_name: "",
    spouse_fullnames: "",
    spouse_gender: "",
    spouse_race: "",
    spouse_rsa_id: "",

    // Section D - Dependents (array of dependents)
    dependents_surname: "",
    dependents_initial: "",
    dependents_id_number: "",
    dependents_age: "",
    dependents_relationship: "",
    dependents_gender: "",

    // Section E - Monthly Income
    applicant_employment: "",
    spouse_employment: "",
    monthly_income: "",
    joint_income: "",
    bond_amount: "",

    // Section F - Citizenship
    citizen: "",

    // Section G - Property Details
    property_seller: "",
    property_township: "",
    property_erf_number: "",

    // Section H - Funding Details
    funding_total_price: "",
    funding_home_loan: "",

    // Section I - Conveyancer Details
    conveyancer_name: "",
    conveyancer_postal_address: "",
    conveyancer_postal_code: "",
    conveyancer_fee: "",
    conveyancer_phone: "",

    // Section J - Lender (FLISP)
    lender_name: "",
    lender_postal_address: "",
    lender_postal_code: "",
    lender_phone: ""

  })

  // Generic handler
  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData((prev) => ({ ...prev, [name]: value }))
  }

  const jsonData = {
    "8705240910089": {
      "database": "Western Cape",
      "name": "KHOLISILE, B",
      "id_number": "8705240910089",
      "status": "Approved",
      "application_type": "FLISP - Finance Linked Individual Subsidy",
      "area": "BLUE DOWNS",
      "site_number": "37699",
      "project": "COCT: The Property Bank: Forest Village Estate: 362 - FLISP - Ph2 (2023/2024)(W18080003/2)",
      "construction_status": "Not Stipulated",
      "happy_letter": ""
    },
    "7611275650080": {
      "database": "Western Cape",
      "name": "MAZITSHANA, XP",
      "id_number": "7611275650080",
      "status": "Approved",
      "application_type": "FLISP - Finance Linked Individual Subsidy",
      "area": "BLUE DOWNS",
      "site_number": "37705",
      "project": "COCT: The Property Bank: Forest Village Estate: 362 - FLISP - Ph 1  (2020/2023)(W18080003/1)",
      "construction_status": "Not Stipulated",
      "happy_letter": ""
    },
    "7802240084089": {
      "database": "Western Cape",
      "name": "LEWIS, EA",
      "id_number": "7802240084089",
      "status": "Approved",
      "application_type": "FLISP - Finance Linked Individual Subsidy",
      "area": "BLUE DOWNS",
      "site_number": "36468",
      "project": "COCT: The Property Bank: Malibu Village & The Conifers: 500 - FLISP - Ph1: 245 (2018-2022)(W18080004/1)",
      "construction_status": "Not Stipulated",
      "happy_letter": ""
    },
    "9503080036084": {
      "database": "Western Cape",
      "name": "SOLOMONS, CD",
      "id_number": "9503080036084",
      "status": "Approved",
      "application_type": "FLISP - Finance Linked Individual Subsidy",
      "area": "BLUE DOWNS",
      "site_number": "36465",
      "project": "COCT: The Property Bank: Malibu Village & The Conifers: 500 - FLISP - Ph1: 245 (2018-2022)(W18080004/1)",
      "construction_status": "Not Stipulated",
      "happy_letter": ""
    },
    "9212210662088": {
      "database": "Western Cape",
      "name": "PETER, Z",
      "id_number": "9212210662088",
      "status": "Approved",
      "application_type": "FLISP - Finance Linked Individual Subsidy",
      "area": "BLUE DOWNS",
      "site_number": "37112",
      "project": "COCT: The Property Bank: Forest Village Converted ASLA & WK 452 - FLISP - Ph 1: ASLA - 360(W18080002/1)",
      "construction_status": "Not Stipulated",
      "happy_letter": ""
    },
    "9204215590086": {
      "database": "",
      "name": "",
      "id_number": "9204215590086",
      "status": "",
      "application_type": "",
      "area": "",
      "site_number": "",
      "project": "",
      "construction_status": "",
      "happy_letter": ""
    },
    "9207110809086": {
      "database": "Western Cape",
      "name": "MNYANI, SS",
      "id_number": "9207110809086",
      "status": "Approved",
      "application_type": "FLISP - Finance Linked Individual Subsidy",
      "area": "BLUE DOWNS",
      "site_number": "37139",
      "project": "COCT: The Property Bank: Forest Village Estate: 362 - FLISP - Ph2 (2023/2024)(W18080003/2)",
      "construction_status": "Not Stipulated",
      "happy_letter": ""
    },
    "9411015279086": {
      "database": "Western Cape",
      "name": "NDABENI, S",
      "id_number": "9411015279086",
      "status": "Approved",
      "application_type": "FLISP - Finance Linked Individual Subsidy",
      "area": "BLUE DOWNS",
      "site_number": "37103",
      "project": "COCT: The Property Bank: Forest Village Converted ASLA & WK 452 - FLISP - Ph 1: ASLA - 360(W18080002/1)",
      "construction_status": "Not Stipulated",
      "happy_letter": ""
    },
    "9201270130086": {
      "database": "Western Cape",
      "name": "FORTUIN, SS",
      "id_number": "9201270130086",
      "status": "Approved",
      "application_type": "FLISP - Finance Linked Individual Subsidy",
      "area": "BLUE DOWNS",
      "site_number": "37719",
      "project": "COCT: The Property Bank: Forest Village Estate: 362 - FLISP - Ph2 (2023/2024)(W18080003/2)",
      "construction_status": "Not Stipulated",
      "happy_letter": ""
    },
    "9210275281083": {
      "database": "Western Cape",
      "name": "SIMMERS, DD",
      "id_number": "9210275281083",
      "status": "Approved",
      "application_type": "FLISP - Finance Linked Individual Subsidy",
      "area": "BLUE DOWNS",
      "site_number": "37100",
      "project": "COCT: The Property Bank: Forest Village Estate: 362 - FLISP - Ph2 (2023/2024)(W18080003/2)",
      "construction_status": "Not Stipulated",
      "happy_letter": ""
    }
  };

  const isUnavailable = !apiBaseUrl;  

  useEffect(() => {
    if (!selectedText || isUnavailable) return;

    setInputValue(selectedText);

    if (inputRef.current) {
    inputRef.current.focus();
    }
  }, [selectedText, isUnavailable]);

  // Close menu if clicked outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setMenuOpen(false);
        setSubmenuOpen(false);
      }
    };

    if (menuOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [menuOpen]);

  const handleSubmit = () => {
    const query = inputValue.trim();
    if (!query || isUnavailable) return;
    
    // If user is not yet on /new-chat page, navigate there first
    if (location.pathname !== "/new-chat") {
      navigate("/new-chat", { state: { query } });
      return;
    }

    setInputValue("");

    // Show typing indicator
    if (onResponse) onResponse(null, query);

    //Always hit /ask endpoint
    const url = `${apiBaseUrl.replace(/\/+$/, "")}/ask/`;

    //Payload format exactly as required
    const payload = {
      question: query,
      userid: user?.user_id || "",                             
      thread_id: user?.threadId || 0,
      timezone: Intl?.DateTimeFormat()?.resolvedOptions()?.timeZone || ""
    };

    const options = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    };    

    fetch(url, options)
      .then((res) => res.json())
      .then((result) => {
        if (onResponse) {
          const answer = result?.data?.answer || "No response available.";
          const suggestions = result?.data?.suggestions || [];
          const sources = result?.data?.sources || [];
          const msgId = result?.data?.message_id || '';
          onResponse(answer, query, { suggestions, sources, id: msgId });
        }

        //If backend gives a new parent_thread_id, save it globally        
        const newThreadId = result?.thread_id || result?.data?.parent_thread_id || 0;
        setUser((prevUser) => ({
          ...prevUser,
          threadId: newThreadId,
        }));
        
        // Trigger sidebar refresh after successful ask
        if (window?.chatReloadThreads) {
          window.chatReloadThreads();
        }

      })
      .catch((err) => {
        console.error("API Error:", err);
        if (onResponse) {
          onResponse("Something went wrong. Please try again.", query);
        }
      });
  };


  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleSubmit();
    }
  };

  return (
    <div id="chatBoxInput">
      <div className="chat-input-box">
        {/* Plus Button */}
        <button
          onClick={() => setMenuOpen(!menuOpen)}
          className="plus-button"
          title="Menu"
        >
          +
        </button>

        {/* Text Input */}
        <input
          type="text"
          id="chatInput"
          placeholder={
            isUnavailable
              ? "This BOT is in development mode. Coming soon!"
              : "What can I help with? Ask anything"
          }
          ref={inputRef}
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          onKeyDown={handleKeyDown}
          readOnly={isUnavailable}
          className={`chat-input ${isUnavailable ? "disabled" : ""}`}
        />

        {/* Send Button */}
        {!isUnavailable && inputValue.trim() !== "" && (
          <button onClick={handleSubmit} className="send-button" title="Send">
            <i className="fa fa-paper-plane"></i>
          </button>
        )}
      </div>

      {/* Main Menu Dropdown */}
      {menuOpen && (
        <div className="dropdown-menu" ref={menuRef}>
          <div
            className="menuli"
            onClick={() => {
              setShowPopupMenu1(true);
              setMenuOpen(false);
              setSubmenuOpen(false);
            }}
          >
            Housing Application Status
          </div>

          <div className="menuli" onClick={() => setSubmenuOpen(!submenuOpen)}>
            Housing Application Forms{" "}
            <i className="fa-solid fa-chevron-right"></i>
          </div>

          {/* Submenu */}
          {submenuOpen && (
            <div className="submenu">
              <div
                className="submenu-item active"
                onClick={() => {
                  setShowPopupMenu2(true);
                  setMenuOpen(false);
                  setSubmenuOpen(false);
                }}
              >
                First home finance application form
              </div>
              <div className="submenu-item disabled">
                Individual subsidy application form
              </div>
              <div className="submenu-item disabled">
                Rental application form
              </div>
            </div>
          )}
        </div>
      )}

      {/* Popup Menu1 */}
      {showPopupMenu1 && (
        <div className="popup-overlay" onClick={() => setShowPopupMenu1(false)}>
          <div className="popup-content-menu1" onClick={(e) => e.stopPropagation()}>
            <h2 className="my-3">Housing Application Status</h2>

            {/* Search Box */}
            <div className="form-container my-3">
              <div className="form-group">
                <input
                  type="text"
                  placeholder="ID Number"
                  value={idInput}
                  onChange={(e) => setIdInput(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      e.preventDefault();   // stops accidental form submit
                      e.stopPropagation();  // stops bubbling to chat field
                      const data = jsonData[idInput.trim()];
                      setSearchResult(data || null);
                    }
                  }}
                  className="form-control"
                />
              </div>

              <div className="form-group" style={{ display: "block" }}>
                <button
                  className="button"
                  onClick={() => {
                    const data = jsonData[idInput.trim()];
                    setSearchResult(data || null);
                  }}
                >
                  Search
                </button>

                <button
                  className="button"
                  onClick={() => {
                    setIdInput("");      // clear input box
                    setSearchResult(null);  // reset results so msg shows
                  }}
                >
                  Reset
                </button>
              </div>
            </div>

            {/* Show result if found */}
            {searchResult ? (
              <div className="form-container">
                <div className="form-group">
                  <label>Database:</label>
                  <input type="text" className="form-control" value={searchResult.database} readOnly />
                </div>

                <div className="form-group">
                  <label>Name:</label>
                  <input type="text" className="form-control" value={searchResult.name} readOnly />
                </div>

                <div className="form-group">
                  <label>ID Number:</label>
                  <input type="text" className="form-control" value={searchResult.id_number} readOnly />
                </div>

                <div className="form-group">
                  <label>Status:</label>
                  <input type="text" className="form-control" value={searchResult.status} readOnly />
                </div>

                <div className="form-group">
                  <label>Application Type:</label>
                  <input type="text" className="form-control" value={searchResult.application_type} readOnly />
                </div>

                <div className="form-group">
                  <label>Area:</label>
                  <input type="text" className="form-control" value={searchResult.area} readOnly />
                </div>

                <div className="form-group">
                  <label>Site Number:</label>
                  <input type="text" className="form-control" value={searchResult.site_number} readOnly />
                </div>

                <div className="form-group form-full">
                  <label>Project:</label>
                  <input type="text" className="form-control" value={searchResult.project} readOnly />
                </div>

                <div className="form-group">
                  <label>Construction Status:</label>
                  <input type="text" className="form-control" value={searchResult.construction_status} readOnly />
                </div>

                <div className="form-group">
                  <label>Happy Letter:</label>
                  <input type="text" className="form-control" value={searchResult.happy_letter} readOnly />
                </div>
              </div>
            ) : (
              searchResult === null && <p>Please Enter (valid) ID Number</p>
            )}

            <button
              className="closemenu"
              onClick={() => setShowPopupMenu1(false)}
              style={{ marginTop: "15px" }}
            >
              Close
            </button>
          </div>
        </div>
      )}

      {/* Popup Menu2 */}
      {showPopupMenu2 && (
        <div className="popup-overlay" onClick={() => setShowPopupMenu2(false)}>
          <div
            className="popup-content-menu2"
            onClick={(e) => e.stopPropagation()}
          >
            <h2>Housing Application Forms</h2>

            {/* Section A */}
            {currentStep === "A" && (
              <div className="section">
                <p className="my-3">
                  In case of incomplete information contact: <b>021-483-3654</b>
                </p>

                <div className="form-container">
                  <div className="form-group">
                    <label>Name</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter your name"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="form-group">
                    <label>Postal Address</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter postal address"
                      name="postal_address"
                      value={formData.postal_address}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="form-group">
                    <label>Contact Number</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter contact number"
                      name="contact_number"
                      value={formData.contact_number}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="form-group">
                    <label>Email</label>
                    <input
                      type="email"
                      className="form-control"
                      placeholder="Enter email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                    />
                  </div>
                </div>

                <div className="form-buttons">
                  <button className="closemenu" onClick={() => setShowPopupMenu2(false)}>Close</button>
                  <button className="button nextbutton" onClick={() => setCurrentStep("B")}>Next</button>
                </div>
              </div>
            )}

            {/* Section B */}
            {currentStep === "B" && (
              <div className="section">
                <h2>Section A</h2>

                <div className="form-group mt15">
                  <label>Marital Status:</label>
                  <div className="radio-group">
                    <label>
                      <input
                        type="radio"
                        className="radio"
                        name="marital_status"
                        value="married"
                        checked={formData.marital_status === "married"}
                        onChange={handleChange}
                      /> Married
                    </label>
                    <br />

                    <label>
                      <input
                        type="radio"
                        className="radio"
                        name="marital_status"
                        value="cohabiting"
                        checked={formData.marital_status === "cohabiting"}
                        onChange={handleChange}
                      /> Habitually Co-habituating with long term partner
                    </label>
                    <br />

                    <label>
                      <input
                        type="radio"
                        className="radio"
                        name="marital_status"
                        value="divorced_dependents"
                        checked={formData.marital_status === "divorced_dependents"}
                        onChange={handleChange}
                      /> Divorced with dependents
                    </label>
                    <br />

                    <label>
                      <input
                        type="radio"
                        className="radio"
                        name="marital_status"
                        value="divorced_no_dependents"
                        checked={formData.marital_status === "divorced_no_dependents"}
                        onChange={handleChange}
                      /> Divorced without dependents
                    </label>
                    <br />

                    <label>
                      <input
                        type="radio"
                        className="radio"
                        name="marital_status"
                        value="single_dependents"
                        checked={formData.marital_status === "single_dependents"}
                        onChange={handleChange}
                      /> Single with dependents
                    </label>
                    <br />

                    <label>
                      <input
                        type="radio"
                        className="radio"
                        name="marital_status"
                        value="single_no_dependents"
                        checked={formData.marital_status === "single_no_dependents"}
                        onChange={handleChange}
                      /> Single without dependents
                    </label>
                    <br />

                    <label>
                      <input
                        type="radio"
                        className="radio"
                        name="marital_status"
                        value="widow_dependents"
                        checked={formData.marital_status === "widow_dependents"}
                        onChange={handleChange}
                      /> Widow/Widower with dependents
                    </label>
                    <br />

                    <label>
                      <input
                        type="radio"
                        className="radio"
                        name="marital_status"
                        value="widow_no_dependents"
                        checked={formData.marital_status === "widow_no_dependents"}
                        onChange={handleChange}
                      /> Widow/Widower without dependents
                    </label>
                  </div>
                </div>


                <div className="form-group mt15">
                  <label>Period (in Years):</label>
                  <input
                    type="number"
                    className="form-control"
                    placeholder="Enter number of years"
                    min="0"
                    name="period"
                    value={formData.period}
                    onChange={handleChange}
                  />
                </div>

                <div className="form-buttons" style={{ display: "flex", justifyContent: "space-between", marginTop: "20px" }}>
                  <button className="closemenu" onClick={() => setShowPopupMenu2(false)}>Close</button>
                  <div>
                    <button className="prevbutton" onClick={() => setCurrentStep("A")} style={{ marginRight: "10px" }}>Previous</button>
                    <button className="nextbutton" onClick={() => setCurrentStep("C")}>Next</button>
                  </div>
                </div>
              </div>
            )}

            {/* Section C */}
            {currentStep === "C" && (
              <div className="section">
                <div className="sc-row">
                  {/* Applicant(s) */}
                  <div className="sc-col-6 my-3">
                    <h4>Details of Applicant(s)</h4>

                    <div className="sc-form-group">
                      <label>Surname</label>
                      <input
                        type="text"
                        className="sc-form-control"
                        placeholder="Enter surname"
                        value={formData.applicant_surname}
                        onChange={(e) =>
                          setFormData({ ...formData, applicant_surname: e.target.value })
                        }
                      />
                    </div>

                    <div className="sc-form-group">
                      <label>Maiden name / Former Surname</label>
                      <input
                        type="text"
                        className="sc-form-control"
                        placeholder="Enter maiden name / former surname"
                        value={formData.applicant_maiden_name}
                        onChange={(e) =>
                          setFormData({ ...formData, applicant_maiden_name: e.target.value })
                        }
                      />
                    </div>

                    <div className="sc-form-group">
                      <label>Full names</label>
                      <input
                        type="text"
                        className="sc-form-control"
                        placeholder="Enter full names"
                        value={formData.applicant_fullnames}
                        onChange={(e) =>
                          setFormData({ ...formData, applicant_fullnames: e.target.value })
                        }
                      />
                    </div>

                    <div className="sc-form-group">
                      <label>Gender</label><br />
                      <label>
                        <input
                          type="radio"
                          className="radio"
                          name="applicant_gender"
                          value="male"
                          checked={formData.applicant_gender === "male"}
                          onChange={(e) =>
                            setFormData({ ...formData, applicant_gender: e.target.value })
                          }
                        /> Male
                      </label>{" "}
                      <label>
                        <input
                          type="radio"
                          className="radio"
                          name="applicant_gender"
                          value="female"
                          checked={formData.applicant_gender === "female"}
                          onChange={(e) =>
                            setFormData({ ...formData, applicant_gender: e.target.value })
                          }
                        /> Female
                      </label>
                    </div>

                    <div className="sc-form-group">
                      <label>Race</label><br />
                      {["black", "white", "coloured", "indian", "other"].map((race) => (
                        <label key={race}>
                          <input
                            type="radio"
                            className="radio"
                            name="applicant_race"
                            value={race}
                            checked={formData.applicant_race === race}
                            onChange={(e) =>
                              setFormData({ ...formData, applicant_race: e.target.value })
                            }
                          />{" "}
                          {race.charAt(0).toUpperCase() + race.slice(1)}
                          <br />
                        </label>
                      ))}
                    </div>

                    <div className="sc-form-group">
                      <label>RSA ID Number</label>
                      <input
                        type="text"
                        className="sc-form-control"
                        placeholder="Enter RSA ID Number"
                        value={formData.applicant_rsa_id}
                        onChange={(e) =>
                          setFormData({ ...formData, applicant_rsa_id: e.target.value })
                        }
                      />
                    </div>
                  </div>

                  {/* Spouse */}
                  <div className="sc-col-6 my-3">
                    <h4>Spouse (or Deceased partner)</h4>

                    <div className="sc-form-group">
                      <label>Surname</label>
                      <input
                        type="text"
                        className="sc-form-control"
                        placeholder="Enter surname"
                        value={formData.spouse_surname}
                        onChange={(e) =>
                          setFormData({ ...formData, spouse_surname: e.target.value })
                        }
                      />
                    </div>

                    <div className="sc-form-group">
                      <label>Maiden name / Former Surname</label>
                      <input
                        type="text"
                        className="sc-form-control"
                        placeholder="Enter maiden name / former surname"
                        value={formData.spouse_maiden_name}
                        onChange={(e) =>
                          setFormData({ ...formData, spouse_maiden_name: e.target.value })
                        }
                      />
                    </div>

                    <div className="sc-form-group">
                      <label>Full names</label>
                      <input
                        type="text"
                        className="sc-form-control"
                        placeholder="Enter full names"
                        value={formData.spouse_fullnames}
                        onChange={(e) =>
                          setFormData({ ...formData, spouse_fullnames: e.target.value })
                        }
                      />
                    </div>

                    <div className="sc-form-group">
                      <label>Gender</label><br />
                      <label>
                        <input
                          type="radio"
                          className="radio"
                          name="spouse_gender"
                          value="male"
                          checked={formData.spouse_gender === "male"}
                          onChange={(e) =>
                            setFormData({ ...formData, spouse_gender: e.target.value })
                          }
                        /> Male
                      </label>{" "}
                      <label>
                        <input
                          type="radio"
                          className="radio"
                          name="spouse_gender"
                          value="female"
                          checked={formData.spouse_gender === "female"}
                          onChange={(e) =>
                            setFormData({ ...formData, spouse_gender: e.target.value })
                          }
                        /> Female
                      </label>
                    </div>

                    <div className="sc-form-group">
                      <label>Race</label><br />
                      {["black", "white", "coloured", "indian", "other"].map((race) => (
                        <label key={race}>
                          <input
                            type="radio"
                            className="radio"
                            name="spouse_race"
                            value={race}
                            checked={formData.spouse_race === race}
                            onChange={(e) =>
                              setFormData({ ...formData, spouse_race: e.target.value })
                            }
                          />{" "}
                          {race.charAt(0).toUpperCase() + race.slice(1)}
                          <br />
                        </label>
                      ))}
                    </div>

                    <div className="sc-form-group">
                      <label>RSA ID Number</label>
                      <input
                        type="text"
                        className="sc-form-control"
                        placeholder="Enter RSA ID Number"
                        value={formData.spouse_rsa_id}
                        onChange={(e) =>
                          setFormData({ ...formData, spouse_rsa_id: e.target.value })
                        }
                      />
                    </div>
                  </div>
                </div>

                {/* Navigation buttons */}
                <div
                  className="form-buttons"
                  style={{ display: "flex", justifyContent: "space-between", marginTop: "20px" }}
                >
                  <button
                    className="closemenu"
                    onClick={() => setShowPopupMenu2(false)}
                  >
                    Close
                  </button>
                  <div>
                    <button
                      className="prevbutton"
                      onClick={() => setCurrentStep("B")}
                      style={{ marginRight: "10px" }}
                    >
                      Previous
                    </button>
                    <button
                      className="nextbutton"
                      onClick={() => setCurrentStep("D")}
                    >
                      Next
                    </button>
                  </div>
                </div>
              </div>
            )}

            {/* Section D */}
            {currentStep === "D" && (
              <div className="section">
                <h2>Section D: Details of All Dependents</h2>

                <div className="form-container">
                  <div className="form-group">
                    <label>Surname</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter surname"
                      name="dependents_surname"
                      value={formData.dependents_surname}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="form-group">
                    <label>Initial</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter initial"
                      name="dependents_initial"
                      value={formData.dependents_initial}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="form-group">
                    <label>ID Number or Birth Certificate No.</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter ID/Birth certificate no."
                      name="dependents_id_number"
                      value={formData.dependents_id_number}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="form-group">
                    <label>Age</label>
                    <input
                      type="number"
                      className="form-control"
                      placeholder="Enter age"
                      name="dependents_age"
                      value={formData.dependents_age}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="form-group">
                    <label>Relationship</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter relationship"
                      name="dependents_relationship"
                      value={formData.dependents_relationship}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="form-group">
                    <label>Gender</label>
                    <div>
                      <label>
                        <input
                          type="radio"
                          className="radio"
                          name="dependents_gender"
                          value="male"
                          checked={formData.dependents_gender === "male"}
                          onChange={handleChange}
                        />{" "}
                        Male
                      </label>{" "}
                      <label>
                        <input
                          type="radio"
                          className="radio"
                          name="dependents_gender"
                          value="female"
                          checked={formData.dependents_gender === "female"}
                          onChange={handleChange}
                        />{" "}
                        Female
                      </label>
                    </div>
                  </div>
                </div>

                {/* Navigation buttons */}
                <div
                  className="form-buttons"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginTop: "20px",
                  }}
                >
                  <button className="closemenu" onClick={() => setShowPopupMenu2(false)}>
                    Close
                  </button>
                  <div>
                    <button
                      className="prevbutton"
                      onClick={() => setCurrentStep("C")}
                      style={{ marginRight: "10px" }}
                    >
                      Previous
                    </button>
                    <button className="nextbutton" onClick={() => setCurrentStep("E")}>
                      Next
                    </button>
                  </div>
                </div>
              </div>
            )}

            {/* Section E */}
            {currentStep === "E" && (
              <div className="section">
                <h2>Section E: Monthly Income</h2>

                <table
                  className="table table-bordered my-3"
                  style={{ width: "100%", border: "solid 1px #bebebeff", padding: "10px" }}
                >
                  <thead style={{ border: "solid 1px #bebebeff" }}>
                    <tr>
                      <th>Indicate if you are:</th>
                      <th>Applicant</th>
                      <th>Spouse</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr style={{ border: "solid 1px #bebebeff" }}>
                      <td>Fulltime employed</td>
                      <td>
                        <input
                          type="radio"
                          className="radio"
                          name="applicant_employment"
                          value="fulltime"
                          checked={formData.applicant_employment === "fulltime"}
                          onChange={handleChange}
                        />
                      </td>
                      <td>
                        <input
                          type="radio"
                          className="radio"
                          name="spouse_employment"
                          value="fulltime"
                          checked={formData.spouse_employment === "fulltime"}
                          onChange={handleChange}
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>Self employed</td>
                      <td>
                        <input
                          type="radio"
                          className="radio"
                          name="applicant_employment"
                          value="self"
                          checked={formData.applicant_employment === "self"}
                          onChange={handleChange}
                        />
                      </td>
                      <td>
                        <input
                          type="radio"
                          className="radio"
                          name="spouse_employment"
                          value="self"
                          checked={formData.spouse_employment === "self"}
                          onChange={handleChange}
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>Social welfare</td>
                      <td>
                        <input
                          type="radio"
                          className="radio"
                          name="applicant_employment"
                          value="welfare"
                          checked={formData.applicant_employment === "welfare"}
                          onChange={handleChange}
                        />
                      </td>
                      <td>
                        <input
                          type="radio"
                          className="radio"
                          name="spouse_employment"
                          value="welfare"
                          checked={formData.spouse_employment === "welfare"}
                          onChange={handleChange}
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>

                <div className="form-container my-3">
                  <div className="sc-form-group">
                    <label>Basic Monthly Income</label>
                    <div className="sc-input-group">
                      <span className="sc-input-group-text">R</span>
                      <input
                        type="number"
                        className="sc-form-control"
                        name="monthly_income"
                        value={formData.monthly_income}
                        onChange={handleChange}
                      />
                    </div>
                  </div>

                  <div className="sc-form-group">
                    <label>Joint Total (Applicant & Spouse)</label>
                    <div className="sc-input-group">
                      <span className="sc-input-group-text">R</span>
                      <input
                        type="number"
                        className="sc-form-control"
                        name="joint_income"
                        value={formData.joint_income}
                        onChange={handleChange}
                      />
                    </div>
                  </div>

                  <div className="sc-form-group">
                    <label>Amount of bond applied for</label>
                    <div className="sc-input-group">
                      <span className="sc-input-group-text">R</span>
                      <input
                        type="number"
                        className="sc-form-control"
                        name="bond_amount"
                        value={formData.bond_amount}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                </div>

                {/* Navigation buttons */}
                <div
                  className="form-buttons"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginTop: "20px",
                  }}
                >
                  <button className="closemenu" onClick={() => setShowPopupMenu2(false)}>
                    Close
                  </button>
                  <div>
                    <button
                      className="prevbutton"
                      onClick={() => setCurrentStep("D")}
                      style={{ marginRight: "10px" }}
                    >
                      Previous
                    </button>
                    <button className="nextbutton" onClick={() => setCurrentStep("F")}>
                      Next
                    </button>
                  </div>
                </div>
              </div>
            )}

            {/* Section F */}
            {currentStep === "F" && (
              <div className="section">
                <h2>Section F: Details of Citizenship</h2>

                <div className="my-3">
                  <label>Are you a South African Citizen?</label><br />
                  <label>
                    <input
                      type="radio"
                      className="radio"
                      name="citizen"
                      value="yes"
                      checked={formData.citizen === "yes"}
                      onChange={handleChange}
                    />{" "}
                    Yes
                  </label>{" "}
                  <label>
                    <input
                      type="radio"
                      className="radio"
                      name="citizen"
                      value="no"
                      checked={formData.citizen === "no"}
                      onChange={handleChange}
                    />{" "}
                    No
                  </label>
                </div>

                {/* Navigation buttons */}
                <div
                  className="form-buttons"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginTop: "20px"
                  }}
                >
                  <button
                    className="closemenu"
                    onClick={() => setShowPopupMenu2(false)}
                  >
                    Close
                  </button>
                  <div>
                    <button
                      className="prevbutton"
                      onClick={() => setCurrentStep("E")}
                      style={{ marginRight: "10px" }}
                    >
                      Previous
                    </button>
                    <button
                      className="nextbutton"
                      onClick={() => setCurrentStep("G")}
                    >
                      Next
                    </button>
                  </div>
                </div>
              </div>
            )}

            {/* Section G */}
            {currentStep === "G" && (
              <div className="section">
                <h2>Section G: Details of Property to be Purchased</h2>

                <div className="form-container my-3">
                  <div className="form-group">
                    <label>Name of Seller</label>
                    <input
                      type="text"
                      className="form-control"
                      name="property_seller"
                      value={formData.property_seller}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="form-group">
                    <label>Township</label>
                    <input
                      type="text"
                      className="form-control"
                      name="property_township"
                      value={formData.property_township}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="form-group">
                    <label>ERF (Stand)/Lot Number</label>
                    <input
                      type="text"
                      className="form-control"
                      name="property_erf_number"
                      value={formData.property_erf_number}
                      onChange={handleChange}
                    />
                  </div>
                </div>

                {/* Navigation buttons */}
                <div
                  className="form-buttons"
                  style={{ display: "flex", justifyContent: "space-between", marginTop: "20px" }}
                >
                  <button
                    className="closemenu"
                    onClick={() => setShowPopupMenu2(false)}
                  >
                    Close
                  </button>
                  <div>
                    <button
                      className="prevbutton"
                      onClick={() => setCurrentStep("F")}
                      style={{ marginRight: "10px" }}
                    >
                      Previous
                    </button>
                    <button
                      className="nextbutton"
                      onClick={() => setCurrentStep("H")}
                    >
                      Next
                    </button>
                  </div>
                </div>
              </div>
            )}

            {/* Section H */}
            {currentStep === "H" && (
              <div className="section">
                <h2>Section H: Funding Details</h2>

                <div className="form-container my-3">
                  <div className="sc-form-group">
                    <label>Total Product Price</label>
                    <div className="sc-input-group">
                      <span className="sc-input-group-text">R</span>
                      <input
                        type="number"
                        className="sc-form-control"
                        name="funding_total_price"
                        value={formData.funding_total_price}
                        onChange={handleChange}
                      />
                    </div>
                  </div>

                  <div className="sc-form-group">
                    <label>Amount of Home Loan</label>
                    <div className="sc-input-group">
                      <span className="sc-input-group-text">R</span>
                      <input
                        type="number"
                        className="sc-form-control"
                        name="funding_home_loan"
                        value={formData.funding_home_loan}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                </div>

                {/* Navigation buttons */}
                <div
                  className="form-buttons"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginTop: "20px"
                  }}
                >
                  <button
                    className="closemenu"
                    onClick={() => setShowPopupMenu2(false)}
                  >
                    Close
                  </button>
                  <div>
                    <button
                      className="prevbutton"
                      onClick={() => setCurrentStep("G")}
                      style={{ marginRight: "10px" }}
                    >
                      Previous
                    </button>
                    <button
                      className="nextbutton"
                      onClick={() => setCurrentStep("I")}
                    >
                      Next
                    </button>
                  </div>
                </div>
              </div>
            )}

            {/* Section I */}
            {currentStep === "I" && (
              <div className="section">
                <h2>Section I: Details of Conveyancer</h2>

                <div className="form-container my-3">
                  <div className="form-group">
                    <label>Name</label>
                    <input
                      type="text"
                      className="form-control"
                      name="conveyancer_name"
                      value={formData.conveyancer_name}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="form-group">
                    <label>Postal Address</label>
                    <input
                      type="text"
                      className="form-control"
                      name="conveyancer_postal_address"
                      value={formData.conveyancer_postal_address}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="form-group">
                    <label>Postal Code</label>
                    <input
                      type="text"
                      className="form-control"
                      name="conveyancer_postal_code"
                      value={formData.conveyancer_postal_code}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="sc-form-group">
                    <label>Conveyance Fee</label>
                    <div className="sc-input-group">
                      <span className="sc-input-group-text">R</span>
                      <input
                        type="number"
                        className="sc-form-control"
                        name="conveyancer_fee"
                        value={formData.conveyancer_fee}
                        onChange={handleChange}
                      />
                    </div>
                  </div>

                  <div className="form-group">
                    <label>Telephone No</label>
                    <input
                      type="text"
                      className="form-control"
                      name="conveyancer_phone"
                      value={formData.conveyancer_phone}
                      onChange={handleChange}
                    />
                  </div>
                </div>

                {/* Navigation buttons */}
                <div
                  className="form-buttons"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginTop: "20px"
                  }}
                >
                  <button
                    className="closemenu"
                    onClick={() => setShowPopupMenu2(false)}
                  >
                    Close
                  </button>
                  <div>
                    <button
                      className="prevbutton"
                      onClick={() => setCurrentStep("H")}
                      style={{ marginRight: "10px" }}
                    >
                      Previous
                    </button>
                    <button
                      className="nextbutton"
                      onClick={() => setCurrentStep("J")}
                    >
                      Next
                    </button>
                  </div>
                </div>
              </div>
            )}

            {/* Section J */}
            {currentStep === "J" && (
              <div className="section">
                <h2>Section J: Details of Lender for a FLISP Application</h2>

                <div className="form-container my-3">
                  <div className="form-group">
                    <label>Name</label>
                    <input
                      type="text"
                      className="form-control"
                      name="lender_name"
                      value={formData.lender_name}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="form-group">
                    <label>Postal Address</label>
                    <input
                      type="text"
                      className="form-control"
                      name="lender_postal_address"
                      value={formData.lender_postal_address}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="form-group">
                    <label>Postal Code</label>
                    <input
                      type="text"
                      className="form-control"
                      name="lender_postal_code"
                      value={formData.lender_postal_code}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="form-group">
                    <label>Telephone No</label>
                    <input
                      type="text"
                      className="form-control"
                      name="lender_phone"
                      value={formData.lender_phone}
                      onChange={handleChange}
                    />
                  </div>
                </div>

                {/* Navigation buttons */}
                <div
                  className="form-buttons"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginTop: "20px"
                  }}
                >
                  <button
                    className="closemenu"
                    onClick={() => setShowPopupMenu2(false)}
                  >
                    Close
                  </button>
                  <div>
                    <button
                      className="prevbutton"
                      onClick={() => setCurrentStep("I")}
                      style={{ marginRight: "10px" }}
                    >
                      Previous
                    </button>
                    <button
                      className="nextbutton"
                      onClick={() => setCurrentStep("K")}
                    >
                      Next
                    </button>
                  </div>
                </div>
              </div>
            )}

            {currentStep === "K" && (
              <div className="section">
                <div className="text-center mt-3">
                  <h3 className="text-red">**PLEASE NOTE: faxed or emailed applications are not accepted**</h3>
                  <p className="lead">
                    The original application and certified copies of all supporting documents<br /> must either be
                    hand-delivered or posted to the following address:
                  </p>
                </div>
                <div className="mt-3">
                  <strong>Hand-delivered:</strong> Helpdesk, Ground Floor, 27 Wale Street, Cape Town, 8001
                </div>
                <div>
                  <strong>Post:Attention: </strong>Subsidy Administration, Private Bag X9083, Cape Town, 8000
                </div>
                <p className="note">
                  <strong>NOTE: </strong>Kindly complete all highlighted sections/or MARKED with an <strong>“X”</strong>
                </p>

                {/* Navigation buttons */}
                <div
                  className="form-buttons"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginTop: "20px"
                  }}
                >
                  <button
                    className="closemenu"
                    onClick={() => setShowPopupMenu2(false)}
                  >
                    Close
                  </button>
                  <div>
                    <button
                      className="prevbutton"
                      onClick={() => setCurrentStep("J")}
                      style={{ marginRight: "10px" }}
                    >
                      Previous
                    </button>
                    <button
                      className="nextbutton"
                      onClick={() => {
                        window.open(
                          "/assets/steps_docs/first_home_finance_application_form.pdf",
                          "_blank"
                        )
                      }}
                    >
                      Review and Print
                    </button>
                  </div>
                </div>
              </div>
            )}

          </div>
        </div>
      )}

    </div>
  );
}

export default Chat;